/**
 * Safely serializes an object to a JSON string, handling circular references.
 *
 * If a circular reference is detected within the object, it replaces the reference with the string '[Circular]'.
 * Optionally, you can specify the indentation level for pretty-printing the output.
 *
 * @param obj - The object to serialize.
 * @param indent - Optional number of spaces to use as white space for indentation in the output JSON string.
 * @returns The JSON string representation of the object, with circular references replaced.
 */
export function safeStringify(obj: any, indent?: number): string {
    const seen = new WeakSet()
    return JSON.stringify(
        obj,
        (key, value) => {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return "[Circular]"
                seen.add(value)
            }
            return value
        },
        indent
    )
}
